import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { AnalystPublicProfileModel } from '@app/shared/models/analystPublicProfileModel';
import { environment } from '@env/environment';
import swal from 'sweetalert2';
import { NickNameModalService } from '@app/feature/main/roles-shared/services/nick-name-modal.service';
import { AnalystHighlightsModel } from '@app/shared/models/AnalystHighlightsModel';
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { ConnectService } from '@app/shared/services/connect.service';
import { AccessToken as MyAccessToken } from "@app/util/accessToken";
import { ConnectMiniProfileComponent } from '../connect-mini-profile/connect-mini-profile.component';
import { CommentModalService } from '@app/shared/services/comment-modal.service';
import { LikeModalServiceService } from "@app/shared/services/like-modal-service.service";
import { Paginator } from "primeng/paginator";
import { PackageSubscriptionService } from '@app/feature/main/roles-shared/services/package-subscription.service';
import { LinkShareComponent } from '../link-share/link-share.component';
import { Location } from '@angular/common';
import { CreateProjectService } from '@app/shared/services/create-project/create-project.service';
import { ServiceProvidersService } from '@app/feature/main/roles-shared/services/service-providers.service';
import { RatingAndReviewService } from '@app/feature/main/roles-shared/services/rating-and-review.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription, Observable } from 'rxjs';
import { User } from '@app/shared/models/user';
import { EBSUser } from '@app/shared/models/ebs-user';

declare var $: any;

@Component({
  selector: 'app-tech-analyst-profile',
  templateUrl: './tech-analyst-profile.component.html',
  styleUrls: ['./tech-analyst-profile.component.css']
})
export class TechAnalystProfileComponent implements OnInit {
  public modalRef: BsModalRef;
  @ViewChild(ConnectMiniProfileComponent) connectionMini: ConnectMiniProfileComponent;
  @ViewChild("paginatorId") paginator = new Paginator();
  @ViewChild(LinkShareComponent) linkShareModal: LinkShareComponent;
  datalist = [];
  packages = [];
  isActiveID: string;
  techDomainListData: object;
  noDataCheck: boolean = false;
  selectedTab: string;
  skipValue = 0;
  totalRecords = 0;
  techDomainListselected = null;
  searchString = "";
  rating = 0;
  analystId: any;
  userRole: any;
  loggedInStatus: any;
  userDetailsObject: any;
  userId: any;
  socialSkip = 0;
  socialLimit = 4;
  totalSocialFeedCount: number;
  connectStatus: any = {};
  AnalystHighlights: any = {
    data: []
  }

  analystPublicProfilePage: any = new AnalystPublicProfileModel();

  skillsEndosements: any = {
    data: [],
    totalCount: 0
  }
  focusAreasEndosements: any = {
    data: [],
    totalCount: 0
  }
  marketsEndosements: any = {
    data: [],
    totalCount: 0
  }
  serviceEndosements: any = {
    data: [],
    totalCount: 0
  }
  
  industriesEndosements: any = {
    data: [],
    totalCount: 0
  }
  techAnalystBlogsList: Array<object> = [];
  techAnalystUpcomingReportsList: Array<object> = [];
  socialFeedsData: Array<Object> = [];
  profileViewMore: boolean = false;

  analystBiograhyLength: boolean;
  analystBiograhyShowStatus: boolean = false;
  skip = 0;
  limit = 5;
  industryskip = 0;
  industrylimit = 5;
  marketskip = 0;
  marketlimit = 5;
  focusareaskip = 0;
  focusarealimit = 5;
  serviceskip = 0;
  servicelimit = 5;
  skillEndorsementViewMoreStatus: boolean = true;
  focusAreaEndorsementViewMoreStatus: boolean = true;
  marketEndorsementViewMoreStatus: boolean = true;
  industriesEndorsementViewMoreStatus: boolean = true;
  serviceEndorsementViewMoreStatus: boolean = true;
  blogURL: string;
  wpAutoLoginUrl: string = '';
  currentTab: string;
  upComingReportCount = 0;
  upcomingReportLimit = 2;
  upComingReportViewButton = true;
  upReportsDescription: any = [];
  reviewCount: number;
  highlights: any;
  userSubscription$: Subscription;
  followCount: number;
  analystDetails:any;
  userSignInSubscription$: Subscription;
  isUserSignedIn: boolean;
  currentUser: any;
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private activeRoute: ActivatedRoute,
    private rolesSharedService: RolesSharedService,
    private authenticationService: AuthenticationService,
    private breadcrumService: BreadcrumService,
    private nickNameModalService: NickNameModalService,
    private commentModalService: CommentModalService,
    private router: Router,
    private connectService: ConnectService,
    private myAccessToken: MyAccessToken,
    private likeModalService: LikeModalServiceService,
    private packageSubscriptionService: PackageSubscriptionService,
    private urlLocation: Location,
    private createProjectService:CreateProjectService,
    private serviceProviderService:ServiceProvidersService,
    private ratingAndReviewService: RatingAndReviewService,
    private modalService: BsModalService,
  ) {
    this.blogURL = environment.BLOG_URL;
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    // window.scroll(0, 0);
    this.document.body.classList.add('inner-page');
    this.document.body.classList.remove('outer-page');
  }

  ngOnInit() {
    this.userSignInSubscription$ = this.authenticationService.currentEBSUser.subscribe(
      (userData: EBSUser) => {
        this.isUserSignedIn = userData.id ? true : false;
        if (this.isUserSignedIn) {
          this.currentUser = userData;
        }
      }
    );
    this.getParamsData();
    this.isLoggedIn();
    this.userDetails();
    this.getRole();
    this.getProfilePageDetails();
    this.getAnalystDetails();
    this.getUpcomingReports();
    this.getBlogsList();
    this.getSkillsEndorsement();
    this.getFocusAreasEndosements();
    this.getMarketsEndosements();
    this.getIndustriesEndosements();
    this.getServiceEndorsement();
    this.getAnalystHighlights();
    this.socialFeeds();
    this.clearBredcumLabels();
    this.currentTab = 'service';
    this.isLoggedIn();
    this.userDetails();
    this.getSubPackagelist();
    this.getDomainList();
    this.getSpSocialFeeds(this.socialLimit, this.socialSkip);

    this.techDomainListselected = window.localStorage.getItem('selectedTechDomainId') ?
      window.localStorage.getItem('selectedTechDomainId') : null
  }
  applyFilter(event?: any) {
    const filter: any = {};
    filter.search = this.searchString;
    this.getSubPackagelist();
  }

  // temp fix need to change next release
  clearBredcumLabels() {
    const BC3Url = sessionStorage.getItem('BC3Url');
    if (BC3Url) {
      sessionStorage.removeItem('BC3Url');
    }
  }

  analystListNavigate() {
    if (this.userRole && this.userRole !== 'tech-analyst') {
      this.router.navigate([`${this.userRole}/analyst-list`]);
    } else {
      this.router.navigate(["analyst-list"]);
    }
  }


  navigateToPage(feedData) {
    if (this.loggedInStatus) {
      if (feedData.postType === 'comment' || feedData.postType === 'like') {
        this.feedNavigation(feedData.itemType, feedData);
      } else {
        this.feedNavigation(feedData.postType, feedData);
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }
  error(data) {
    if (data === false) {
      swal('Sorry', 'You cannot rate this Analyst!', 'info');
    }
  }

  feedNavigation(type, feedData) {
    switch (type) {
      case 'analyst': this.routeTechAnalystProfilePage(feedData.id, feedData.title); break;
      case 'tech_domain': this.router.navigate([`${this.userRole}/social-feeds`]); break;
      case 'research_document': this.navRoute(feedData); break;
      case 'report': this.navRoute(feedData); break;
      case 'admin_social_announcement': this.router.navigate([`${this.userRole}/social-feeds`]); break;
      case 'follow': this.routeTechAnalystProfilePage(feedData.id, ''); break;
      case 'blog': this.navtoFeedBlog(feedData.ID); break;
      case 'like': this.navRoute(feedData); break;
      case 'comment': this.navRoute(feedData); break;
      default: this.router.navigate([`${this.userRole}/social-feeds`]); break;
    }
  }

  navRoute(data?: any) {
    if (data.itemType === 'report' || data.postType === 'report') {
      this.breadcrumService.setUrl('BC3Label', data.title);
      if (this.userRole === "tech-analyst") {
        this.router.navigate([`${this.userRole}/reports/report-details/${data.postId}`]);
      } else {
        this.router.navigate([`${this.userRole}/report-details/${data.postId}`]);
      }
    } else if (data.itemType === 'research_document' || data.postType === 'research_document') {
      this.breadcrumService.setUrl('BC3Label', data.researchDocumentName || data.title);
      if (this.userRole === "tech-vendor") {
        this.router.navigate([`${this.userRole}/market-data/${data.postId}`]);
      } else {
        this.router.navigate([`${this.userRole}/research-snapshot/${data.postId}`]);
      }

    } else if (data.postType === 'follow' && !data.itemType) {
      this.routeTechAnalystProfilePage(data.id, '');
    } else {
      this.router.navigate([`${this.userRole}/social-feeds`]);
    }
  }

  getParamsData() {
    this.analystId = this.activeRoute.snapshot.queryParams.analystId;
    this.getConnectionStatus();
  }

  getConnectionStatus() {
    if (sessionStorage.getItem('userDetails')) {
      this.connectService.getProfileSnapshot(this.analystId).subscribe(
        (data: any) => {
          this.connectStatus = data.connectData;
        },
        error => {

        }
      )
    }
  }
  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  showMoreDescription(index) {
    this.upReportsDescription[index] = true;
  }

  showLessDescription(index) {
    this.upReportsDescription[index] = false;
  }
  changeTab(selectedItem: string) {
    this.currentTab = selectedItem;
  }
  mapPostData(researchData: any) {
    let data: any = {}
    data = {
      postId: this.analystId,
      rating: this.rating,
      userId: this.userId,
      postType: 'analyst'
    }
    return data
  }

  trigerRatingOutput(researchData: any) {
    if (this.loggedInStatus) {
      this.rolesSharedService.rating(JSON.stringify(this.mapPostData(researchData))).subscribe((response: any) => {

        if (response) {
          this.rating = response.rating ? response.rating : 0;
          this.getProfilePageDetails();
          this.closeRatingModal();
        }
      })
    } else {
      this.closeRatingModal();
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  closeRatingModal() {
    $('#ratingModal').modal('hide');
  }

  skillsEndorsementFilter() {
    let filter: any = {};
    filter.limit = this.limit;
    filter.skip = this.skip;
    return filter;
  }

  serviceEndorsementFilter() {
    let filter: any = {};
    filter.limit = this.servicelimit;
    filter.skip = this.serviceskip;
    return filter;
  }

  focusareaEndorsementFilter() {
    let filter: any = {};
    filter.limit = this.focusarealimit;
    filter.skip = this.focusareaskip;
    
    return filter;
  }

  industryEndorsementFilter() {
    let filter: any = {};
    filter.limit = this.industrylimit;
    filter.skip = this.industryskip;
    return filter;
  }

  marketEndorsementFilter() {
    let filter: any = {};
    filter.limit = this.marketlimit;
    filter.skip = this.marketskip;
    return filter;
  }

  endorsementViewMore(endorsement: string, viewMore: boolean) {
    switch (endorsement) {
      case 'service':
        if (viewMore) {
          this.servicelimit += 5;
        }
        else {
          this.servicelimit = 5;
        }
        this.getServiceEndorsement();
        break;
      case 'industry':
        if (viewMore) {
          this.industrylimit += 5;
        }
        else {
          this.industrylimit = 5;
        }
        this.getIndustriesEndosements();
        break;
      case 'market':
        if (viewMore) {
          this.marketlimit += 5;
        }
        else {
          this.marketlimit = 5;
        }
        this.getMarketsEndosements();
        break;
      case 'focusArea':
        if (viewMore) {
          this.focusarealimit += 5;
        }
        else {
          this.focusarealimit = 5;
        }
        this.getFocusAreasEndosements();
        break;
      case 'skills':
        if (viewMore) {
          this.limit += 5;
        }
        else {
          this.limit = 5;
        }
        this.getSkillsEndorsement();
        break;
      default:
        break;
    }
  }


  getProfilePageDetails() {
    this.rolesSharedService.getTechAnalystPublicProfile(this.analystId).subscribe((response: any) => {

      this.analystPublicProfilePage = response;
      this.analystPublicProfilePage.reports.sort((a,b) => {
        return <any>new Date(b.createdAt) - <any>new Date(a.createdAt)
      });

      if (this.analystBiograhyLength = this.analystPublicProfilePage.biography) {
        if (this.analystPublicProfilePage.biography.length >= 300) {
          this.analystBiograhyLength = true;
        } else {
          this.analystBiograhyLength = false;
        }
      }
      if (this.analystPublicProfilePage.myRatings) {
        this.rating = this.analystPublicProfilePage.myRatings.rating
      } else {
        this.rating = 0;
      }
    })
  }

  followAnalyst() {
    // FIX: Sign-in validation before follow Analyst

    if (this.loggedInStatus) {
      const filter: any = {};
      filter.filter = JSON.stringify({
        analystUserId: this.analystId,
        followerUserId: this.userId
      });
      this.rolesSharedService.analystFollow(filter.filter).subscribe(
        followResponse => {

          if (followResponse["followed"]) {
            this.analystPublicProfilePage.isFollow = true;
            this.analystPublicProfilePage.followerCount += 1;
          } else if (!followResponse["followed"]) {
            this.analystPublicProfilePage.isFollow = false;
            this.analystPublicProfilePage.followerCount -= 1;
          }
        });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  upcommingReportsFilts() {
    let filter: any = {};
    filter.filter = JSON.stringify({
      where: {
        createdBy: this.analystId
      },
      include: ["likes", "comments", "ratings"]
    });
    return filter;
  }

  getUpcomingReports() {
    const filter: any = {};
    filter.analystUserId = this.analystId;
    filter.limit = this.upcomingReportLimit;
    // this.rolesSharedService.getTechAnalystUpcommingReportsPublicProfile(this.upcommingReportsFilts()).subscribe((response: any) => {
    this.rolesSharedService.getTechAnalystUpcommingReportList(filter).subscribe((response: any) => {
      this.techAnalystUpcomingReportsList = response.data;
      this.upComingReportCount = response.totalCount;
      if (this.techAnalystUpcomingReportsList.length < this.upComingReportCount && this.upComingReportCount > 2) {
        this.upComingReportViewButton = true;
      } else if (this.techAnalystUpcomingReportsList.length >= this.upComingReportCount) {
        this.upComingReportViewButton = false;
      }
    });
  }

  showMoreUpcomingReports() {
    this.upcomingReportLimit += 2;
    this.getUpcomingReports();
  }

  showLessUpcomingReports() {
    this.upcomingReportLimit = 2;
    this.getUpcomingReports();
  }

  showMoreReports() {

  }

  getBlogsList() {
    this.rolesSharedService.getTechAnalystBlogsPublicProfile(this.analystId).subscribe((response: any) => {

      this.techAnalystBlogsList = response;
    })
  }
  
  
  getMarketsEndosements() {
    this.rolesSharedService.getTechAnalystMarketEndorsementPublicProfile(this.marketEndorsementFilter(), this.analystId).subscribe((response: any) => {
      if (response.data) {
        this.marketsEndosements.data = response.data;
        this.marketsEndosements.data.length = response.data.length;
      }
      if (response.totalCount > 0) {
        this.marketsEndosements.totalCount = response.totalCount
      } else {
        this.marketsEndosements.totalCount = 0;
      }

      if (this.marketsEndosements.data.length == response.totalCount) {
        this.marketEndorsementViewMoreStatus = false;
      } else {
        this.marketEndorsementViewMoreStatus = true;
      }
    })
  }

  

  getFocusAreasEndosements() {
    this.rolesSharedService.getTechAnalystFocusAreasEndorsementPublicProfile(this.focusareaEndorsementFilter(), this.analystId).subscribe((response: any) => {

      if (response.data) {
        this.focusAreasEndosements.data = response.data;
        this.focusAreasEndosements.data.length = response.data.length;
      }
      if (response.totalCount > 0) {
        this.focusAreasEndosements.totalCount = response.totalCount
      } else {
        this.focusAreasEndosements.totalCount = 0;
      }

      if (this.focusAreasEndosements.data.length == response.totalCount) {
        this.focusAreaEndorsementViewMoreStatus = false;
      } else {
        this.focusAreaEndorsementViewMoreStatus = true;
      }
    })
  }

  getSkillsEndorsement() {
    this.rolesSharedService.getTechAnalystSkillsEndorsementPublicProfile(this.skillsEndorsementFilter(), this.analystId).subscribe((response: any) => {

      if (response.data) {
        this.skillsEndosements.data = response.data;
        this.skillsEndosements.data.length = response.data.length;
      }
      if (response.totalCount > 0) {
        this.skillsEndosements.totalCount = response.totalCount
      } else {
        this.skillsEndosements.totalCount = 0;
      }

      if (this.skillsEndosements.data.length == response.totalCount) {
        this.skillEndorsementViewMoreStatus = false;
      } else {
        this.skillEndorsementViewMoreStatus = true;
      }
    })
  }

  getIndustriesEndosements() {
    this.rolesSharedService.getTechAnalystIndustriesEndorsementPublicProfile(this.industryEndorsementFilter(), this.analystId).subscribe((response: any) => {
      if (response.data) {
        this.industriesEndosements.data = response.data;
        this.industriesEndosements.data.length = response.data.length;
      }
      if (response.totalCount > 0) {
        this.industriesEndosements.totalCount = response.totalCount
      } else {
        this.industriesEndosements.totalCount = 0;
      }

      if (this.industriesEndosements.data.length == response.totalCount) {
        this.industriesEndorsementViewMoreStatus = false;
      } else {
        this.industriesEndorsementViewMoreStatus = true;
      }
    })
  }

  getServiceEndorsement() {
    this.rolesSharedService.getTechAnalystServiceEndorsementPublicProfile(this.serviceEndorsementFilter(), this.analystId).subscribe((response: any) => {
      if (response.data) {
        this.serviceEndosements.data = response.data;
        this.serviceEndosements.data.length = response.data.length;
      }
      if (response.totalCount > 0) {
        this.serviceEndosements.totalCount = response.totalCount
      } else {
        this.serviceEndosements.totalCount = 0;
      }

      if (this.serviceEndosements.data.length == response.totalCount) {
        this.serviceEndorsementViewMoreStatus = false;
      } else {
        this.serviceEndorsementViewMoreStatus = true;
      }
    })
  }

  endorseSkillToggle(skillsEndosement: any) {

    // FIX: Sign-in validation before Endorsement

    if (this.loggedInStatus) {

      this.rolesSharedService.endorseSkill(skillsEndosement.skillMappingId).subscribe((response: any) => {

        if (response["endorse"]) {
          skillsEndosement.isEndorsed = true;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        } else if (!response["endorse"]) {
          skillsEndosement.isEndorsed = false;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        }
      });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }
  endorseFocusAreaToggle(focusAreasEndosements: any) {

    // FIX: Sign-in validation before Endorsement

    if (this.loggedInStatus) {

      this.rolesSharedService.endorseFocusArea(focusAreasEndosements.focusAreaMappingId).subscribe((response: any) => {

        if (response["endorse"]) {
          focusAreasEndosements.isEndorsed = true;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        } else if (!response["endorse"]) {
          focusAreasEndosements.isEndorsed = false;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        }
      });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  endorseMarketToggle(marketsEndosements: any) {

    // FIX: Sign-in validation before Endorsement

    if (this.loggedInStatus) {

      this.rolesSharedService.endorseMarket(marketsEndosements.marketMappingId).subscribe((response: any) => {

        if (response["endorse"]) {
          marketsEndosements.isEndorsed = true;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        } else if (!response["endorse"]) {
          marketsEndosements.isEndorsed = false;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        }
      });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  endorseIndustriesToggle(industriesEndosements: any) {

    // FIX: Sign-in validation before Endorsement

    if (this.loggedInStatus) {

      this.rolesSharedService.endorseIndustry(industriesEndosements.industryMappingId).subscribe((response: any) => {

        if (response["endorse"]) {
          industriesEndosements.isEndorsed = true;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        } else if (!response["endorse"]) {
          industriesEndosements.isEndorsed = false;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        }
      });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  endorseServiceToggle(serviceEndosements: any) {

    // FIX: Sign-in validation before Endorsement

    if (this.loggedInStatus) {

      this.rolesSharedService.endorseService(serviceEndosements.serviceMappingId).subscribe((response: any) => {

        if (response["endorse"]) {
          serviceEndosements.isEndorsed = true;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        } else if (!response["endorse"]) {
          serviceEndosements.isEndorsed = false;
          // skillsEndosement.endorseCount = skillsEndosement.endorseCount - 1;
        }
      });

    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  navtoBlogs() {
    window.open(this.blogURL, '_self');
  }

  isAccessible(id: string) {
    if (this.loggedInStatus) {
      if (this.userRole === "tech-analyst") {
        this.router.navigate([`${this.userRole}/reports/report-details/${id}`]);
      } else {
        this.router.navigate([`${this.userRole}/report-details/${id}`]);
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  like(postData, index) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        const likeObject = {
          postId: postData.id,
          postType: "upcoming_report",
          userId: this.userId
        };
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {

        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        })
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }

  openCommentModal(data) {
    data.type = "upcoming_report";
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
    if (this.loggedInStatus && this.userDetailsObject != undefined && this.userDetailsObject.nickName) {
      this.commentModalService.modalStatus(true, data);
    } else {
      this.nickNameModalService.openNickNameModal();
    }
  }

  populateComments(data) {
    if(data){
      data.type = "upcoming_report";
      if (this.userDetailsObject.nickName) {
        data.showComments = !data.showComments;
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    }
   
  }

  openLikeModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
    }
    if (this.loggedInStatus) {
      this.likeModalService.modalStatus(true, data);
    }
  }
  AnalystHighlightsFilter() {
    let filter: any = {};
    filter.limit = 5
    filter.analystId = this.analystId
    filter.sort = 'publishedAt DESC';
    return filter
  }

  getAnalystHighlights() {
    this.rolesSharedService.getAnalystHighlights(this.AnalystHighlightsFilter()).subscribe((response: any) => {

      this.AnalystHighlights.data = response.data || []
    })
  }

  socialFeedsFilter() {
    let filter: any = {};
    filter.limit = 0;
    filter.skip = 0;
    filter.analystId = this.analystId;
    // filter.sort = { 'postDate': 'DESC' };
    return filter;
  }

  socialFeeds() {
    this.rolesSharedService.getSocialFeedList(this.socialFeedsFilter()).subscribe((response: any) => {
      this.socialFeedsData = response.data;
    }, (error) => {
      swal("Info", error.error.error.message, "info");
    });
  }

  routeAllReports() {
    this.router.navigate(['public-profile-all-reports'], { queryParams: { analystId: this.analystId } })
  }

  routeUpcommingReports() {
    this.router.navigate(['public-profile-upcoming-reports'], { queryParams: { analystId: this.analystId } })
  }

  scrollToSkillsEndorsment() {
    var elmnt = document.getElementById("skillEndorse");
    elmnt.scrollIntoView();
  }

  viewBiography() {
    this.analystBiograhyShowStatus = !this.analystBiograhyShowStatus;
    if (!this.analystBiograhyShowStatus) {
      window.scroll(0, 0);
    }

  }
  navigateToConnect() {
    this.router.navigate([`${this.userRole}/my-connections`]);
  }
  connect() {
    this.connectService.connectUser(this.analystId).subscribe((data: any) => {
      swal("Success", "Request sent successfully.", "success");
      this.navigateToConnect();
    }, (error) => {
      if (error.status === 401) {
        // fix reditect login
        this.router.navigate(["/signin"]);
      }
      else {
        swal("Info", error.error.error.message, "info");
      }
    });
  }
  navtoFeedBlog(id?: any) {
    let token = this.myAccessToken.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&id=${id}`;
      window.open(blogUrl, '_self');
    }
    else {
      this.router.navigate(["/signin"]);
    }
  }

  showUserDetails(data) {
    const token = this.myAccessToken.getToken();
    if (token) {
      if (data && data.code === 'tech_analyst') {
        const fullName = data.firstName + '' + data.lastName;
        this.routeTechAnalystProfilePage(data.id, fullName);
      } else if (data && data.code && data.code !== 'super_admin') {
        this.connectionMini.getProfileData(data.id);
      }
      else if (data && data.postType === 'analyst') {
        const fullName = data.title;
        this.routeTechAnalystProfilePage(data.postId, fullName);
      }
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  routeTechAnalystProfilePage(analystId: string, fullName: string) {
    this.breadcrumService.setUrl('BC3Label', fullName);
    sessionStorage.setItem('analystName', fullName);
    this.router.navigate(["analyst-profile"], {
      queryParams: { analystId: analystId }
    });
  }

  navtoPackageSubsList() {
    // this.removeSession();
    this.router.navigate(["package-subscription"]);

  }
  getSubPackagelist() {
    let searchKey = this.searchString;
    this.packageSubscriptionService.getSubPackagelist(this.reportsDataFilter()).subscribe((res: any) => {
      if (searchKey === this.searchString) {
        this.datalist = res.data;
        this.packages=[];
        for (let i = 0; i < this.datalist.length; i++) {
          for (let j = 0; j < this.datalist[i].authors.length; j++) {
            if(this.datalist[i].authors[j].userId==this.analystId){
              this.packages.push(this.datalist[i]);
              j= this.datalist[i].authors.length;
            }
          }          
        }
        if (this.packages["length"] === 0) {
          this.noDataCheck = true;
        } else {
          this.noDataCheck = false;
        }
      }
    });
  }
  reportsDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({

      include: [
        "users",
        "domains",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" }
      ]
    });

    filter.search = this.searchString;

    return filter;
  }

  getDomainList() {
    this.rolesSharedService.getTechDomainsList().subscribe(data => {
      this.techDomainListData = data;
    });
  }

  onScrollDown() {
    if (this.paginator) {
      this.paginator.first = 0;
    }
    if (this.selectedTab === "allReports") {
      this.skipValue = this.skipValue + 9;
      if (this.totalRecords > this.skipValue) {
        this.getSubPackagelist();
      }
    }
  }

  getSpSocialFeeds(feedLimit, feedSkip) {
    const limit = feedLimit;
    const skip = feedSkip;
    const userId = this.userId;
    const search = '';

  }
  onScrollSocialFeeds() {
    this.socialSkip += this.socialLimit;
    if (this.socialSkip < this.totalSocialFeedCount) {
      this.getSpSocialFeeds(this.socialLimit, this.socialSkip);
    }
  }

  getHrefUrl(id: string, title: string, amount: number) {
    if (this.loggedInStatus) {
      // if (this.userRole === "tech-analyst") {
      return `${document.location.origin}/#/package-subscription/package-details/${id}`;//working

      //  return `${document.location.origin}/#/package-subscription/package-data/${id}`;
      /*  } else {
         return `${document.location.origin}/#/${this.userRole}/package-details/${id}`;
       } */
    } else if (!this.loggedInStatus) {
      // fix reditect login
      return `${document.location.origin}/#/signin`;
    }
  }

  getHrefAnalystUrl(analystId: string) {
    return `${document.location.origin}/#/analyst-profile?analystId=${analystId}`;
  }

  showShareModal(type, item) {
    this.linkShareModal.showModal(type, item);
  }
  likeClick(postData, index) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        let likeObject;
        likeObject = {
          postId: postData.id,
          postType: "package_subscription",
          userId: this.userId
        };
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }
  convertNumber(endorsement) {
    return parseInt(endorsement);
  }

  goBack(){
    this.urlLocation.back();
  }

  onRequestQuote() {
    this.createProjectService.setNormalMode();
    const analyst = [this.analystDetails];
    // const accountType = this.serviceProviders.userDetails[0].type;
    // this.createProjectService.setAccountType(accountType);
    this.createProjectService.setServiceProviderInfo(analyst);
    if (!this.isUserSignedIn) {
      this.router.navigate(['/signin']);
    } else {
      this.router.navigate([`${this.userRole}/create-project/project-form`]);
    }
  }

  getSpHighlights() {
    this.serviceProviderService
      .getUserHighlights(this.userId, this.limit, 0)
      .subscribe(
        highlights => (this.highlights = highlights.userHighlightsData)
      );
  }

  getUserReviewList(item, postType) {
    if (this.isLoggedIn) {
      this.ratingAndReviewService.getReviewList(this.userId).subscribe(
        (data: any) => {
          if (data) {
            const initialState = {
              userRatingsListData: data,
              postType,
              postId: this.userId,
              // isMyProfile: this.userId === this.currentUser.id
            };
            // this.modalRef = this.modalService.show(RatingListComponent, {
            //   class: 'modal-dialog-centered modal-lg',
            //   initialState
            // });
          }
        },
        err => {}
      );
    } else {
      this.redirectToLogin();
    }
  }
  redirectToLogin() {
    this.router.navigate(['/login'], {
      queryParams: {
        redirectUrl: `/analyst-profile/${this.userId}`
      }
    });
  }

  showFollowersList() {
    if (this.followCount > 0) {
      const initialStateData = {
        counts: this.followCount,
        userId: this.userId
      };
      // this.followersModalRef = this.modalService.show(FollowersListComponent, {
      //   class: 'modal-dialog-centered modal-md',
      //   initialState: initialStateData
      // });
    }
  }

  getAnalystDetails(){
    this.serviceProviderService.getAnalystDetails(this.analystId).subscribe((data)=>{
      this.analystDetails=data;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tech-analyst-profile/tech-analyst-profile.component.ts